import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "@/components/seo/SEO";
import { Eyebrow, SectionHeading, AmbientOrbs } from "@/components/common/ui";

/**
 * Generic index/landing page for Trust · Solutions · Industries.
 * Driven by a list of `{slug, en:{title,desc}, nl:{title,desc}}` items.
 */
export default function IndexHubPage({ eyebrow, title, sub, basePath, items, testIdPrefix, seoTitle }) {
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";

  return (
    <>
      <SEO title={seoTitle || title} description={sub} path={basePath} />
      <section className="relative overflow-hidden py-32 lg:py-44">
        <AmbientOrbs />
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <Eyebrow>{eyebrow}</Eyebrow>
          <SectionHeading title={title} sub={sub} className="mt-4" />
          <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {items.map((it, i) => (
              <Link
                key={it.slug}
                to={`/${lang}${basePath}/${it.slug}`}
                className="group flex flex-col rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 transition-colors hover:border-bht-gold/30"
                data-testid={`${testIdPrefix}-${it.slug}`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-bht-gold">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-mono text-[10px] tracking-widest text-white/30 transition-colors group-hover:text-bht-gold">→</span>
                </div>
                <div className="mt-8 font-serif text-2xl group-hover:text-bht-gold">{it[lang].title}</div>
                <p className="mt-3 text-sm text-white/55">{it[lang].desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
